import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'pb-12 md:pb-16',
    title:
      'heading-2xl md:heading-3xl container px-6 py-7 font-medium md:pt-12 md:pb-8 md:font-medium',
    map: 'min-h-150',
    error: 'container'
  },
  variants: {
    color: {
      primary: 'text-main'
    }
  },
  defaultVariants: {
    color: 'primary'
  }
});
